import {
	createStore,
	applyMiddleware,
	compose
} from 'redux';
import { apiMiddleware } from 'redux-api-middleware';
import { thunk } from 'redux-thunk';
import rootReducer from './reducers';


const initialState = {};
const enhancers = [];
const middleware = [
	thunk,
	apiMiddleware
];

if (__DEV__) {
	const { devToolsExtension } = window;
	if (typeof devToolsExtension === 'function') {
		enhancers.push(devToolsExtension());
	}
}

const composedEnhancers = compose(
	applyMiddleware(...middleware),
	...enhancers
);

const store = createStore(
	rootReducer,
	initialState,
	composedEnhancers
);

export default store;
